(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["talisloom-collection-grid"] && !Shopify.designMode) return;
  try {
    
  class TalisloomCollectionGrid extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.sidebar = this.querySelector('[data-filters]');
      this.trigger = this.querySelector('[data-filters-trigger]');
      this.closeButtons = this.querySelectorAll('[data-filters-close]');
      this.backdrop = this.querySelector('[data-filters-backdrop]');
      this.sortSelect = this.querySelector('[data-sort-select]');
      this.viewMoreButtons = this.querySelectorAll('[data-filters-toggle]');
      this.syncMetafieldFilters();
      if (!this.sidebar && !this.sortSelect && this.viewMoreButtons.length === 0) {
        this.initialized = true;
        return;
      }
      this.handleTriggerClick = () => this.toggleSidebar();
      this.handleCloseClick = () => this.closeSidebar();
      this.handleKeydown = (event) => this.onKeydown(event);
      this.handleSortChange = (event) => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', event.target.value);
        window.location.assign(url.toString());
      };
      this.handleViewMore = (event) => this.toggleFilterGroup(event.currentTarget);
      this.sidebarMedia = window.matchMedia?.('(max-width: 989px)');
      this.handleSidebarMediaChange = () => {
        if (!this.sidebarMedia?.matches) this.closeSidebar({ restoreFocus: false });
        else this.syncSidebarState(this.sidebar.classList.contains('is-open'));
      };
      this.bindEvents();
      this.syncSidebarState(false);
      this.initialized = true;
    }

    syncMetafieldFilters() {
      const currentUrl = new URL(window.location.href);
      const filterLinks = this.querySelectorAll('[data-metafield-filter] a[data-filter-param][data-filter-value]');

      filterLinks.forEach((link) => {
        const filterParam = link.dataset.filterParam;
        const filterValue = link.dataset.filterValue;
        if (!filterParam || !filterValue) return;

        const selectedValues = currentUrl.searchParams.getAll(filterParam);
        const isActive = selectedValues.includes(filterValue);
        const nextUrl = new URL(currentUrl);
        nextUrl.searchParams.delete(filterParam);
        const nextValues = isActive
          ? selectedValues.filter((value) => value !== filterValue)
          : [...selectedValues, filterValue];
        nextValues.forEach((value) => nextUrl.searchParams.append(filterParam, value));

        link.href = `${nextUrl.pathname}${nextUrl.search}`;
        link.classList.toggle('is-active', isActive);
        link.setAttribute('aria-pressed', String(isActive));
        if (isActive) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      });
    }

    bindEvents() {
      if (this.trigger && this.sidebar) {
        this.trigger.addEventListener('click', this.handleTriggerClick);
      }

      if (this.sortSelect) {
        this.sortSelect.addEventListener('change', this.handleSortChange);
      }

      this.closeButtons.forEach((button) => button.addEventListener('click', this.handleCloseClick));
      this.addEventListener('keydown', this.handleKeydown);
      if (this.sidebarMedia?.addEventListener) this.sidebarMedia.addEventListener('change', this.handleSidebarMediaChange);

      this.viewMoreButtons.forEach((button) => {
        button.addEventListener('click', this.handleViewMore);
      });

    }

    disconnectedCallback() {
      if (!this.initialized) return;
      this.trigger?.removeEventListener('click', this.handleTriggerClick);
      this.sortSelect?.removeEventListener('change', this.handleSortChange);
      this.closeButtons.forEach((button) => button.removeEventListener('click', this.handleCloseClick));
      this.removeEventListener('keydown', this.handleKeydown);
      if (this.sidebarMedia?.removeEventListener) this.sidebarMedia.removeEventListener('change', this.handleSidebarMediaChange);
      this.viewMoreButtons.forEach((button) => button.removeEventListener('click', this.handleViewMore));
      this.closeSidebar({ restoreFocus: false });
      this.initialized = false;
    }

    onKeydown(event) {
      if (!this.sidebar?.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.closeSidebar();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = Array.from(this.sidebar.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'));
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    toggleFilterGroup(button) {
      const group = button.closest('.tl-collection__group');
      if (!group) return;
      const isExpanded = group.dataset.expanded === 'true';
      group.dataset.expanded = String(!isExpanded);
      button.setAttribute('aria-expanded', String(!isExpanded));
      const nextLabelKey = isExpanded ? 'viewMore' : 'viewLess';
      const labels = {
        viewMore: button.dataset.viewMoreLabel || 'View more',
        viewLess: button.dataset.viewLessLabel || 'View less',
      };
      button.textContent = labels[nextLabelKey];
    }

    toggleSidebar() {
      if (!this.sidebar || !this.trigger) return;
      if (this.sidebar.classList.contains('is-open')) this.closeSidebar();
      else this.openSidebar();
    }

    openSidebar() {
      this.storedFocus = document.activeElement;
      this.sidebar.classList.add('is-open');
      this.syncSidebarState(true);
      this.backdrop?.classList.add('is-visible');
      this.trigger?.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('tl-menu-open');
      this.sidebar.querySelector('[data-filters-close]')?.focus();
    }

    closeSidebar({ restoreFocus = true } = {}) {
      if (!this.sidebar) return;
      this.sidebar.classList.remove('is-open');
      this.syncSidebarState(false);
      this.backdrop?.classList.remove('is-visible');
      this.trigger?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('tl-menu-open');
      if (restoreFocus) (this.storedFocus || this.trigger)?.focus?.();
      this.storedFocus = null;
    }

    syncSidebarState(isOpen) {
      if (!this.sidebar) return;
      if (this.sidebarMedia?.matches) {
        this.sidebar.setAttribute('aria-hidden', String(!isOpen));
        this.sidebar.inert = !isOpen;
      } else {
        this.sidebar.removeAttribute('aria-hidden');
        this.sidebar.inert = false;
      }
    }
  }

  if (!customElements.get('talisloom-collection-grid')) customElements.define('talisloom-collection-grid', TalisloomCollectionGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["talisloom-gift-finder"] && !Shopify.designMode) return;
  try {
    
  class GiftFinder extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.finder = this.querySelector('.tl-gift-finder');
      this.form = this.querySelector('[data-finder-form]');
      this.steps = Array.from(this.querySelectorAll('[data-step]'));
      this.nextButton = this.querySelector('[data-next]');
      this.budgetSelect = this.querySelector('[data-budget-select]');
      this.previousButton = this.querySelector('[data-previous]');
      this.progress = this.querySelector('[data-progress]');
      this.hint = this.querySelector('[data-step-hint]');
      this.results = this.querySelector('[data-results]');
      this.primaryResults = this.querySelector('[data-primary-results]');
      this.secondaryResults = this.querySelector('[data-secondary-results]');
      this.showMoreButton = this.querySelector('[data-show-more]');
      this.startOverButton = this.querySelector('[data-start-over]');
      this.emptyResult = this.querySelector('[data-result-empty]');
      this.productPool = Array.from(this.querySelectorAll('[data-result-product]')).map((product) => product.cloneNode(true));
      if (!this.finder || !this.form || this.steps.length === 0 || !this.nextButton) return;

      this.storageKey = `talisloom-gift-finder:${window.location.pathname}`;
      this.currentIndex = 0;
      this.secondaryPage = 0;
      this.restoredSecondaryPage = 0;
      this.handleNext = () => this.next();
      this.handlePrevious = () => this.previous();
      this.handleChange = () => {
        this.updateStepState();
        this.persistState();
      };
      this.handleShowMore = () => this.showMore();
      this.handleStartOver = () => this.startOver();
      this.nextButton.addEventListener('click', this.handleNext);
      this.previousButton?.addEventListener('click', this.handlePrevious);
      this.form.addEventListener('change', this.handleChange);
      this.showMoreButton?.addEventListener('click', this.handleShowMore);
      this.startOverButton?.addEventListener('click', this.handleStartOver);
      this.initialized = true;
      this.finder.classList.add('is-ready');
      this.classList.add('is-ready');
      this.updateStepState();
      this.restoreState();
    }

    disconnectedCallback() {
      if (!this.initialized) return;
      this.nextButton.removeEventListener('click', this.handleNext);
      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.form.removeEventListener('change', this.handleChange);
      this.showMoreButton?.removeEventListener('click', this.handleShowMore);
      this.startOverButton?.removeEventListener('click', this.handleStartOver);
      this.finder?.classList.remove('is-ready');
      this.initialized = false;
    }

    currentStep() {
      return this.steps[this.currentIndex];
    }

    selectedInputs(step = this.currentStep()) {
      return Array.from(step.querySelectorAll('input:checked'));
    }

    readState() {
      const params = new URLSearchParams(window.location.search);
      const stateKeys = [...this.steps.map((step) => `gf_${step.dataset.step}`), 'gf_budget', 'gf_results', 'gf_step'];
      const hasQueryState = stateKeys.some((key) => params.has(key));
      if (hasQueryState) {
        return {
          ...Object.fromEntries(this.steps.map((step) => [step.dataset.step, params.getAll(`gf_${step.dataset.step}`)])),
          budget: params.get('gf_budget') || '',
          results: params.get('gf_results') === '1',
          step: params.get('gf_step'),
          secondaryPage: params.get('gf_secondary_page'),
        };
      }

      try {
        const saved = window.sessionStorage.getItem(this.storageKey);
        return saved ? JSON.parse(saved) : null;
      } catch {
        return null;
      }
    }

    restoreState() {
      const state = this.readState();
      if (!state) return;

      this.steps.forEach((step) => {
        const values = state[step.dataset.step] || [];
        step.querySelectorAll('input').forEach((input) => {
          input.checked = values.includes(input.value);
        });
      });
      if (this.budgetSelect) this.budgetSelect.value = state.budget || '';

      const savedIndex = Number.parseInt(state.step, 10);
      if (Number.isInteger(savedIndex)) {
        this.currentIndex = Math.min(Math.max(savedIndex, 0), this.steps.length - 1);
      }
      this.updateStepState();

      if (state.results && this.steps.filter((step) => step.dataset.step !== 'meaning').every((step) => this.selectedInputs(step).length > 0)) {
        this.restoredSecondaryPage = Math.max(Number.parseInt(state.secondaryPage, 10) || 0, 0);
        this.showResults({ focus: false, persist: false });
        this.secondaryPage = Math.min(this.restoredSecondaryPage, Math.max(this.secondaryProducts.length ? Math.ceil(this.secondaryProducts.length / 3) - 1 : 0, 0));
        this.renderSecondary();
      }
    }

    persistState() {
      const url = new URL(window.location.href);
      const state = {
        results: !this.results.hidden,
        step: this.currentIndex,
        secondaryPage: this.secondaryPage,
        budget: this.budgetSelect?.value || '',
      };

      this.steps.forEach((step) => {
        const key = step.dataset.step;
        const values = this.selectedInputs(step).map((input) => input.value);
        state[key] = values;
        url.searchParams.delete(`gf_${key}`);
        values.forEach((value) => url.searchParams.append(`gf_${key}`, value));
      });
      url.searchParams.delete('gf_budget');
      if (state.budget) url.searchParams.set('gf_budget', state.budget);

      url.searchParams.set('gf_step', String(this.currentIndex));
      if (state.results) {
        url.searchParams.set('gf_results', '1');
        url.searchParams.set('gf_secondary_page', String(this.secondaryPage));
      } else {
        url.searchParams.delete('gf_results');
        url.searchParams.delete('gf_secondary_page');
      }
      window.history.replaceState(window.history.state, '', url.toString());

      try {
        window.sessionStorage.setItem(this.storageKey, JSON.stringify(state));
      } catch {
        // Private browsing and storage restrictions should not block the finder.
      }
    }

    clearState() {
      const url = new URL(window.location.href);
      [...this.steps.map((step) => `gf_${step.dataset.step}`), 'gf_budget', 'gf_results', 'gf_step', 'gf_secondary_page'].forEach((key) => url.searchParams.delete(key));
      window.history.replaceState(window.history.state, '', url.toString());
      try {
        window.sessionStorage.removeItem(this.storageKey);
      } catch {
        // Private browsing and storage restrictions should not block the finder.
      }
    }

    canContinue() {
      const selected = this.selectedInputs();
      return this.currentStep().dataset.step === 'meaning' ? selected.length <= 2 : selected.length > 0;
    }

    updateStepState() {
      const selected = this.selectedInputs();
      const canContinue = this.canContinue();
      const isMeaningStep = this.currentStep().dataset.step === 'meaning';
      this.currentStep().querySelectorAll('input[type="checkbox"]').forEach((input) => {
        input.disabled = isMeaningStep && !input.checked && selected.length >= 2;
      });
      this.nextButton.disabled = !canContinue;
      this.hint.textContent = isMeaningStep
        ? (selected.length > 2 ? this.hint.dataset.maxMeaningLabel : this.hint.dataset.optionalLabel)
        : this.hint.dataset.defaultLabel;
      this.hint.hidden = isMeaningStep ? selected.length > 2 : canContinue;
      this.steps.forEach((step, index) => { step.hidden = index !== this.currentIndex; });
      this.previousButton.hidden = this.currentIndex === 0;
      const template = this.progress.dataset.progressTemplate || 'Step __CURRENT__ of __TOTAL__';
      this.progress.textContent = template.replace('__CURRENT__', String(this.currentIndex + 1)).replace('__TOTAL__', String(this.steps.length));
      const buttonLabel = this.currentIndex === this.steps.length - 1 ? this.nextButton.dataset.finishLabel : this.nextButton.dataset.continueLabel;
      this.nextButton.textContent = `${buttonLabel || (this.currentIndex === this.steps.length - 1 ? 'See my matches' : 'Continue')} →`;
    }

    next() {
      if (!this.canContinue()) return;
      if (this.currentIndex < this.steps.length - 1) {
        this.currentIndex += 1;
        this.updateStepState();
        this.persistState();
        this.currentStep().querySelector('input')?.focus();
        return;
      }
      this.showResults();
    }

    previous() {
      if (!this.results.hidden) {
        this.results.hidden = true;
        this.form.hidden = false;
      }
      if (this.currentIndex === 0) return;
      this.currentIndex -= 1;
      this.updateStepState();
      this.persistState();
    }

    selectedTags() {
      const selected = this.steps.flatMap((step) => this.selectedInputs(step).flatMap((input) => (input.dataset.optionTags || '').split(',').map((tag) => tag.trim()).filter(Boolean)));
      if (this.budgetSelect?.selectedOptions[0]?.dataset.optionTags) {
        selected.push(...this.budgetSelect.selectedOptions[0].dataset.optionTags.split(',').map((tag) => tag.trim()).filter(Boolean));
      }
      return selected;
    }

    rankProducts() {
      const selected = this.selectedTags();
      const budget = this.budgetSelect?.value || '';
      const recipient = this.selectedInputs(this.steps.find((step) => step.dataset.step === 'relationship'))[0]?.dataset.optionTags.split(',')[0];
      const occasion = this.selectedInputs(this.steps.find((step) => step.dataset.step === 'occasion'))[0]?.dataset.optionTags.split(',')[0];
      const meaningStep = this.steps.find((step) => step.dataset.step === 'meaning');
      const meanings = this.selectedInputs(meaningStep).map((input) => (input.dataset.optionTags || '').split(',')[0].trim());
      return this.productPool.map((product, index) => {
        const tags = (product.dataset.productTags || '').split(',').map((tag) => tag.trim()).filter(Boolean);
        const recipients = (product.dataset.productRecipients || '').split(',');
        const occasions = (product.dataset.productOccasions || '').split(',');
        const tagScore = selected.reduce((total, selectedTag) => total + (tags.some((tag) => tag === selectedTag || tag.includes(selectedTag) || selectedTag.includes(tag)) ? 1 : 0), 0);
        const budgetMatch = budget ? this.matchesBudget(Number(product.dataset.productPrice || 0) / 100, budget) : true;
        const budgetScore = budget ? (budgetMatch ? 2 : -1) : 0;
        const score = tagScore + budgetScore;
        const meaningMatch = meanings.length === 0 || meanings.some((meaning) => tags.includes(meaning) || (meaning === 'brotherhood' && recipients.includes('brother')));
        const matchesCriteria = meaningMatch && (recipient === 'nobody' || recipients.includes(recipient)) && occasions.includes(occasion) && budgetMatch;
        return { product, index, score, matchesCriteria, available: product.dataset.productAvailable === 'true' };
      }).filter(({ matchesCriteria }) => matchesCriteria).sort((a, b) => Number(b.available) - Number(a.available) || b.score - a.score || a.index - b.index);
    }

    matchesBudget(price, budget) {
      if (!budget) return true;
      if (budget === 'budget-under-40') return price < 40;
      if (budget === 'budget-40-50') return price >= 40 && price <= 50;
      if (budget === 'budget-over-50') return price > 50;
      return false;
    }

    cloneCards(slot, products) {
      slot.replaceChildren();
      products.forEach(({ product }) => {
        const card = product.cloneNode(true);
        card.hidden = false;
        slot.append(card);
      });
    }

    showResults({ focus = true, persist = true } = {}) {
      const ranked = this.rankProducts();
      this.primaryProducts = ranked.slice(0, 3);
      this.secondaryProducts = ranked.slice(3);
      this.secondaryPage = 0;
      this.cloneCards(this.primaryResults, this.primaryProducts);
      this.querySelector('[data-primary-heading]').hidden = ranked.length === 0;
      this.querySelector('.tl-gift-finder__secondary-heading').hidden = this.secondaryProducts.length === 0;
      this.renderSecondary();
      this.emptyResult.hidden = ranked.length > 0;
      this.form.hidden = true;
      this.results.hidden = false;
      if (persist) this.persistState();
      if (focus) this.querySelector('[data-results] h2')?.focus?.();
    }

    renderSecondary() {
      const start = this.secondaryPage * 3;
      const page = this.secondaryProducts.slice(start, start + 3);
      this.cloneCards(this.secondaryResults, page);
      this.showMoreButton.hidden = this.secondaryProducts.length <= start + page.length;
      if (!this.showMoreButton.hidden) this.showMoreButton.textContent = this.secondaryPage === 0 ? this.showMoreButton.dataset.showMoreLabel : this.showMoreButton.dataset.tryAnotherLabel;
    }

    showMore() {
      if (this.secondaryProducts.length === 0) return;
      this.secondaryPage += 1;
      this.renderSecondary();
      this.persistState();
    }

    startOver() {
      this.clearState();
      this.form.reset();
      this.currentIndex = 0;
      this.secondaryPage = 0;
      this.form.hidden = false;
      this.results.hidden = true;
      this.nextButton.textContent = `${this.nextButton.dataset.continueLabel || 'Continue'} →`;
      this.updateStepState();
      this.currentStep().querySelector('input')?.focus();
    }
  }

  if (!customElements.get('talisloom-gift-finder')) customElements.define('talisloom-gift-finder', GiftFinder);

  } catch(e) { console.error(e); }
})();
})();
